/*
  api.js
    api wrapper
    各コンポーネントからは本ファイルで定義されているAPIをコールする。
    本ファイル内では必要に応じて、サーバとの通信を行う

*/

import axios from 'axios'
import { APP_VERSION, isNullorUndefined } from '@/common'
import { sLog } from '@/common/simple-logger'

const SERVER_URI = process.env.HTTP_PRT + '://' + process.env.SERVER_ADDR + ':' + process.env.SERVER_PORT + process.env.SERVER_ROOT_PATH
let axios_http = axios.create({
  baseURL: SERVER_URI,
})
axios_http.defaults.headers['Cache-Control'] = 'no-cache'
//sLog.verbose(JSON.stringify(axios_http.defaults.headers))

// -------------------------------------------------------------------------
const _checkResponseCode = (res) => {
  let result = {
    error: true,
    status: '',
  }

  switch (res.status) {
    case 200:
      sLog.debug('Response Code OK')
      //result.error = res.data.error
      result.error = false
      result.status = 'OK'
      break
    case 400:
      sLog.debug('Bad Request !')
      result.error = true
      result.status = 'Bad Request'
      break
    case 401:
      sLog.debug('Response Code Unauthorized !')
      result.error = true
      result.status = 'Unauthorized'
      break
    case 403:
      sLog.debug('Response Code Forbidden !')
      result.error = true
      result.status = 'Forbidden'
      break
    case 404:
      sLog.debug('Response Code Suspended !')
      result.error = true
      result.status = 'Suspended'
      break
    case 405:
      sLog.debug('Response Code Version Error !')
      result.error = true
      result.status = 'VerError'
      break
    case 406:
      sLog.debug('Response Code IP Certification Error!')
      result.error = true
      result.status = 'IpError'
      break
    default:
      sLog.debug('Unexpected Response Code ' + res.status)
      result.error = true
      result.status = 'Unexpected ' + res.status
      break
  }

  return result
}

// -------------------------------------------------------------------------
// login proc
export async function loginProc (id, password) {
  const API_PATH = '/login'
  sLog.verbose(process.env)
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  const login_data = {
    version: APP_VERSION,
    accountId: id,
    passwd: password
  }

  let result = {}
  await axios_http.post(API_PATH, login_data)
    .then((res) => {
      sLog.info('@api logged in ' + login_data.accountId)
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// login proc by token
export async function loginProcByToken (id, token) {
  const API_PATH = '/login/token'
  sLog.verbose(process.env)
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  const login_data = {
    version: APP_VERSION,
    accountId: id
  }

  let result = {}
  await axios_http.post(API_PATH, login_data)
    .then((res) => {
      sLog.info('@api token logged in ' + login_data.accountId)
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// reissue login token
export async function reissueLoginToken (id, token) {
  const API_PATH = '/login/token/reissue'
  sLog.verbose(process.env)
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  const login_data = {
    accountId: id
  }

  let result = {}
  await axios_http.post(API_PATH, login_data)
    .then((res) => {
      sLog.info('@api reissue token for ' + login_data.accountId)
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })
  return result
}

// -------------------------------------------------------------------------
// change password
export async function changePassword (userId, oldpassword, newpassword, token) {
  const API_PATH = '/userinfo/passwd'
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  const send_data = {
    userId: userId,
    oldpasswd: oldpassword,
    newpasswd: newpassword,
  }
  //sLog.debug(JSON.stringify(send_data))

  let result = {}
  await axios_http.post(API_PATH, send_data)
    .then((res) => {
      sLog.info('@api password changed ' + send_data.userId + JSON.stringify(res))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
//  getUserList
//    UserList取得
export async function getUserList (companyId, token) {
  const API_PATH = '/userinfo/company/' + companyId
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.get(API_PATH)
    .then((res) => {
      sLog.debug('@api getUserList : ' + res.status)
      sLog.verbose('@api getUserList ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// get whereabouts information by member
export async function getWhereaboutsInfoByMember (companyId, memberId, token) {
  const API_PATH = '/whereabouts/company/' + companyId + '/member/' + memberId
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.get(API_PATH)
    .then((res) => {
      sLog.debug('@api getWhereaboutsInfoByMember : ' + res.status)
      sLog.verbose('@api getWhereaboutsInfoByMember' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// updateWhereaboutsInfo
//   サーバの行動予定情報を更新する
//   ※API_PATHのmemberは、更新を行うログインユーザIDを指定する。
export async function updateWhereaboutsInfo (companyId, loginUserId, whereaboutsInfo, token) {
  const API_PATH = '/whereabouts/company/' + companyId + '/member/' + loginUserId
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)
  sLog.debug('@api updateWhereaboutsInfo ' + JSON.stringify(whereaboutsInfo))

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.post(API_PATH, whereaboutsInfo)
    .then((res) => {
      sLog.debug('@api updateWhereaboutsInfo : ' + res.status)
      sLog.verbose('@api updateWhereaboutsInfo ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// getWhereaboutsList
//   行動予定情報一覧取得
export async function getWhereaboutsList (companyId, sectionId, groupId, token) {
  let path = null
  if (isNullorUndefined(groupId)) {
    path = (sectionId === '')
      ? '/whereabouts/company/' + companyId + '/' + APP_VERSION
      : '/whereabouts/company/' + companyId + '/section/' + sectionId + '/' + APP_VERSION
  }
  else {
    path = '/whereabouts/company/' + companyId + '/group/' + groupId + '/' + APP_VERSION
  }

  const API_PATH = path
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.get(API_PATH)
    .then((res) => {
      sLog.debug('@api getWhereaboutsList : ' + res.status)
      sLog.verbose('@api getWhereaboutsList ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// getSectionList
//   グループ一覧取得
export async function getSectionList (companyId, token) {
  const API_PATH = '/departments/company/' + companyId + '/section'
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.get(API_PATH)
    .then((res) => {
      sLog.debug('@api getSectionList : ' + res.status)
      sLog.verbose('@api getSectionList ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// getGroupList
//   グループ一覧取得
export async function getGroupList (companyId, token) {
  const API_PATH = '/departments/company/' + companyId + '/group'
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.get(API_PATH)
    .then((res) => {
      sLog.debug('@api getGroupList : ' + res.status)
      sLog.verbose('@api getGroupList ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// getClassList
//   役職一覧取得
export async function getClassList (companyId, token) {
  const API_PATH = '/departments/company/' + companyId + '/class'
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.get(API_PATH)
    .then((res) => {
      sLog.debug('@api getClassList : ' + res.status)
      sLog.verbose('@api getClassList ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// getPlaceList
//   行先一覧取得
export async function getPlaceList (companyId, token) {
  const API_PATH = '/placelist/company/' + companyId
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.get(API_PATH)
    .then((res) => {
      sLog.debug('@api getPlaceList : ' + res.status)
      sLog.verbose('@api getPlaceList ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// getPresenceStatus
//   在席状態一覧取得
export async function getPresenceStatusList (companyId, token) {
  const API_PATH = '/presencestatus/company/' + companyId
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.get(API_PATH)
    .then((res) => {
      sLog.debug('@api getPresenceStatusList : ' + res.status)
      sLog.verbose('@api getPresenceStatusList ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}
// -------------------------------------------------------------------------
export async function getGeoLocation (companyId, token) {
  const API_PATH = '/geolocations/company/' + companyId
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.get(API_PATH)
    .then((res) => {
      sLog.debug('@api getGeoLocation : ' + res.status)
      sLog.verbose('@api getGeoLocation ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
export async function updateGeoLocation (companyId, memberId, geolocation, token) {
  const API_PATH = '/geolocations/company/' + companyId + '/member/' + memberId
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)
  sLog.debug('@api updateGeoLocation ' + JSON.stringify(geolocation))

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.post(API_PATH, geolocation)
    .then((res) => {
      sLog.debug('@api updateGeoLocation : ' + res.status)
      sLog.verbose('@api updateGeoLocation ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// get avatar info by member
export async function getAvatarInfoByMember (companyId, userId, token) {
  const API_PATH = '/userinfo/avatar/company/' + companyId + '/member/' + userId
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.get(API_PATH)
    .then((res) => {
      sLog.debug('@api getAvatarInfoByMember : ' + res.status)
      sLog.verbose('@api getAvatarInfoByMember' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// upload avatar
export async function uploadAvatar (companyId, userId, avatarImage, token) {
  const API_PATH = '/userinfo/avatar/company/' + companyId + '/member/' + userId
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)
  sLog.debug('@api uploadAvatar ' + avatarImage)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.post(API_PATH, avatarImage)
    .then((res) => {
      sLog.debug('@api uploadAvatar : ' + res.status)
      sLog.verbose('@api uploadAvatar ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// delete avatar
export async function deleteAvatar (companyId, userId, token) {
  const API_PATH = '/userinfo/avatar/company/' + companyId + '/member/' + userId
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.delete(API_PATH)
    .then((res) => {
      sLog.debug('@api deleteAvatar : ' + res.status)
      sLog.verbose('@api deleteAvatar ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}
/*
// -------------------------------------------------------------------------
// get calendar key
export async function getCalendarKeyByMember (companyId, userId, calendarKey) {
  let server = SERVER_URI + '/userinfo/calendar/key/company/' + companyId + '/member/' + userId
  sLog.debug('@api request : ' + server)

  let result = null
  await axios.get(server)
    .then(function (res) {
      sLog.info('@api get calendar key ' + JSON.stringify(res))
      result = res.data
    })
    .catch(function (err) {
      sLog.error(err)
    })

  return result
}

// -------------------------------------------------------------------------
// update calendar key
export async function updateCalendarKey (companyId, userId, calendarKey) {
  let server = SERVER_URI + '/userinfo/calendar/key/company/' + companyId + '/member/' + userId
  sLog.debug('@api request : ' + server)
  sLog.debug(calendarKey)

  const send_data = {
    calendarKey: calendarKey,
  }

  let result = null
  await axios.post(server, send_data)
    .then(function (res) {
      sLog.info('@api calendar key updated ' + JSON.stringify(res))
      result = res.data
    })
    .catch(function (err) {
      sLog.error(err)
    })

  return result
}
*/

// -------------------------------------------------------------------------
export async function sendTeleworkLog (companyId, memberId, teleworkLog, token) {
  const API_PATH = '/telework/reg/company/' + companyId + '/member/' + memberId   // Ver2.2～
  //const API_PATH = '/telework/company/' + companyId + '/member/' + memberId   // ～Ver2.1
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)
  sLog.debug('@api sendTeleworkLog ' + JSON.stringify(teleworkLog))

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.post(API_PATH, teleworkLog)
    .then((res) => {
      sLog.debug('@api sendTeleworkLog : ' + res.status)
      sLog.verbose('@api sendTeleworkLog ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      result.mismatch = err.response.mismatch
      console.assert(result.error, 'System Error - Bad Error Status')
    })
  return result
}

// -------------------------------------------------------------------------
export async function getLatestTeleworkStatus (companyId, memberId, token) {
  const API_PATH = '/telework/company/' + companyId + '/member/' + memberId
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.get(API_PATH)
    .then((res) => {
      sLog.debug('@api getLatestTeleworkStatus : ' + res.status)
      sLog.verbose('@api getLatestTeleworkStatus ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// change telework flg
export async function changeTeleworkFlg (userId, TeleworkFlg, token) {
  const API_PATH = '/telework/flg/'
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  const send_data = {
    userId: userId,
    telework_flg: TeleworkFlg
  }

  let result = {}
  await axios_http.post(API_PATH, send_data)
    .then((res) => {
      sLog.debug('@api changeTeleworkFlg : ' + res.status)
      sLog.verbose('@api changeTeleworkFlg ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// change linked telework flg
export async function changeLinkedTelework (userId, linkedWhFlg, token) {
  const API_PATH = '/telework/linked/'
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  const send_data = {
    userId: userId,
    linked_wh_flg: linkedWhFlg
  }

  let result = {}
  await axios_http.post(API_PATH, send_data)
    .then((res) => {
      sLog.debug('@api changeLinkedTelework : ' + res.status)
      sLog.verbose('@api changeLinkedTelework ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// get telework list
export async function getTeleworkList (companyId, memberId, date, token) {
  const API_PATH = '/telework/company/' + companyId + '/member/' + memberId + '/date/' + date
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.get(API_PATH)
    .then((res) => {
      sLog.debug('@api getTeleworkList : ' + res.status)
      sLog.verbose('@api getTeleworkList ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// get teleworking user list
/*export async function getTeleworkingUserList (companyId, token) {
  const API_PATH = '/telework/company/' + companyId + '/teleworking/'
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.get(API_PATH)
    .then((res) => {
      sLog.debug('@api getTeleworkingUserList : ' + res.status)
      sLog.verbose('@api getTeleworkingUserList ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}*/

// -------------------------------------------------------------------------
// edit telework data
export async function editTeleworkData (data, token) {
  const API_PATH = '/telework/edit/company/' + data.companyId
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.post(API_PATH, data.teleworkLog)
    .then((res) => {
      sLog.info('@api telework data edited ' + JSON.stringify(res))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
// update telework data
export async function deleteTeleworkData (workinghours_id, token) {
  const API_PATH = '/telework/delete/'
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  const send_data = {
    id: workinghours_id,
  }

  let result = {}
  await axios_http.post(API_PATH, send_data)
    .then((res) => {
      sLog.info('@api telework data deleted ' + JSON.stringify(res))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}

// -------------------------------------------------------------------------
export async function sendHolidayInfo (data, token) {
  const API_PATH = '/telework/holiday'
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)
  sLog.debug('@api sendHolidayInfo ' + JSON.stringify(data))

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  let result = {}
  await axios_http.post(API_PATH, data)
    .then((res) => {
      sLog.debug('@api sendHolidayInfo : ' + res.status)
      sLog.verbose('@api sendHolidayInfo ' + JSON.stringify(res.data))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      result.mismatch = err.response.mismatch
      console.assert(result.error, 'System Error - Bad Error Status')
    })
  return result
}

// -------------------------------------------------------------------------
// delete holiday info
export async function deleteHolidayInfo (workinghours_id, token) {
  const API_PATH = '/telework/holiday/delete/'
  sLog.debug('@api request : ' + SERVER_URI + API_PATH)

  axios_http.defaults.headers['Authorization'] = `Bearer ${token}`

  const send_data = {
    id: workinghours_id,
  }

  let result = {}
  await axios_http.post(API_PATH, send_data)
    .then((res) => {
      sLog.info('@api holiday data deleted ' + JSON.stringify(res))
      result = _checkResponseCode(res)
      result.body = res.data
    })
    .catch((err) => {
      sLog.warn(JSON.stringify(err))
      if (!isNullorUndefined(err.response)) {
        result = _checkResponseCode(err.response)
      }
      else {
        result.error = true
        result.status = 'NoResponse'
      }
      console.assert(result.error, 'System Error - Bad Error Status')
    })

  return result
}



// WEBPACK FOOTER //
// ./src/api/index.js